'use strict';

module.exports = function () {
    // Not more present in SFRA.
    $('body').on('click', '[data-collapsible-header]', function (e) {
        e.preventDefault();
        $(this)
            .closest('[data-collapsible]')
            .toggleClass('active');

        if ($(this).closest('[data-collapsible]').hasClass('active')) {
            var activeTitle = $(this).find('button').data('active');
            $(this).find('button').attr('title', activeTitle);
        } else {
            var notActiveTitle = $(this).find('button').data('notactive');
            $(this).find('button').attr('title', notActiveTitle);
        }
    });

    // SFRA 6x version.
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
        $('body').on('click', selector, function (e) {
            e.preventDefault();
            $(this).parents('.collapsible-' + size).toggleClass('active');

            if ($(this).parents('.collapsible-' + size).hasClass('active')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
        });
    });
};
